import React, { useState } from 'react';
import { SubCategory } from '../../types/catalog';
import { useCart } from '../../context/CartContext';
import { formatPrice, hasPrice } from '../../utils/price';
import PriceInquiryModal from '../PriceInquiryModal';

interface ProductActionsProps {
  product: SubCategory;
  compact?: boolean;
}

const ProductActions: React.FC<ProductActionsProps> = ({ product, compact = false }) => {
  const { addItem } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [added, setAdded] = useState(false);
  const priced = hasPrice(product.price);

  const handleAdd = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    addItem({
      id: product.id,
      name: product.name,
      image: product.image,
      price: hasPrice(product.price) ? product.price : null,
      quantity
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  return (
    <div
      className={compact ? 'space-y-2' : 'space-y-4'}
      onClick={(event) => { event.preventDefault(); event.stopPropagation(); }}
    >
      {priced ? (
        <div className={`font-extrabold text-primary ${compact ? 'text-lg' : 'text-2xl'}`}>
          {formatPrice(product.price as number)}
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setInquiryOpen(true)}
          className={`${compact ? 'text-sm px-4 py-2' : 'px-6 py-3'} w-full rounded-xl font-semibold bg-amber-100 text-amber-900 hover:bg-amber-200 transition-colors`}
        >
          Уточнить цену товара у менеджера
        </button>
      )}
      <div className={`flex ${compact ? 'flex-col' : 'items-center'} gap-3`}>
        {!compact && (
          <div className="flex items-center border border-slate-200 rounded-xl overflow-hidden">
            <button
              type="button"
              className="px-3 py-2 text-lg"
              onClick={() => setQuantity((value) => Math.max(1, value - 1))}
            >
              −
            </button>
            <span className="px-4 py-2 min-w-[3rem] text-center">{quantity}</span>
            <button
              type="button"
              className="px-3 py-2 text-lg"
              onClick={() => setQuantity((value) => value + 1)}
            >
              +
            </button>
          </div>
        )}
        <button
          type="button"
          onClick={handleAdd}
          className={`btn-primary ${compact ? 'w-full text-sm py-2' : 'flex-1'}`}
        >
          {added ? 'Добавлено' : 'В корзину'}
        </button>
      </div>
      <PriceInquiryModal
        open={inquiryOpen}
        onClose={() => setInquiryOpen(false)}
        productName={product.name}
      />
    </div>
  );
};

export default ProductActions;
